var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ibox',{attrs:{"title":_vm.title_edit},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var setLoading = ref.setLoading;
return [_c('Form',{attrs:{"slot":"content"},on:{"loading":setLoading},slot:"content"})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }